






























































import {
  computed, defineComponent, reactive, ref,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';

import { createPurchaseRequest } from '@/api';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';

const NOW = useFormat.date().computerShortDate();

const PanelWithMiscPurchaseRequest = defineComponent({
  components: {
    CommonModalWithPreset,
    StickyFooterActionBar,
  },
  props: {
    edit: { default: false },
  },
  setup(props) {
    const toDate = (date: string): string => useFormat.date(date).displayFullThaiDate();
    const successModal = ref(null);
    const form = reactive({
      id: -1,
      dueDate: NOW,
      status: 'PENDING',
      category: 'MISC',
      itemsType: 'MISC',
      remarks: '',
      miscItems: [{
        description: '',
        amount: '',
        unit: '',
        targetDate: NOW,
      }],
      call: async () => {
        if (props.edit) {
          console.log('TO DO : EDIT PR');
        } else {
          await createPurchaseRequest(computedPurchaseRequestInput.value);
        }
        (successModal.value as any).compose({ action: 'บันทึก', entity: 'ใบขอสั่งซื้อ' });
      },
    });
    const computedPurchaseRequestInput = computed(() => ({
      remarks: form.remarks,
      status: form.status,
      dueDate: form.dueDate,
      category: form.category,
      itemsType: form.itemsType,
      miscItems: form.miscItems.map((item: any) => ({
        description: item.description,
        amount: item.amount,
        unit: item.unit,
        targetDate: item.targetDate,
      })).filter((item: any) => item.amount > 0),
    }));

    function addItem() {
      form.miscItems.push({
        description: '',
        amount: '',
        unit: '',
        targetDate: NOW,
      });
    }

    return {
      toDate,
      successModal,
      form,
      addItem,
      NOW,
    };
  },
});

export default PanelWithMiscPurchaseRequest;
